import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Button } from "ui-kit/components";
import { connect } from "react-redux";
import { get } from "lodash";
import { getClassName } from "ui-kit/utils/component";
import Modal from "react-responsive-modal";
import { deleteInvest } from "ducks/user/actions";

import "./CancelDeposit.scss";
import { getCountDecimals, getCurrencySymbol } from '../../../utils/currencyHelper';

export const ccn = getClassName("WithdrawCancelDeposit");

class CancelDeposit extends Component {
  state = {
    modal: false
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  openModal = () => {
    this.setState({ modal: true });
  };

  handleRemoveInvest = () => {
    this.closeModal();
    this.props.deleteInvest({ redirectToDashboard: true });
  };

  render() {
    const  { user } = this.props;
    const { modal } = this.state;

    const invest = get(user, "invest", null);
    const investCountDecimals = getCountDecimals(get(user, "invest.amount"), 2);

    return (
      <div className={ccn("container")}>
        <h1 className={ccn("title")}>
          <FormattedMessage id="hbc.withdraw.title" defaultMessage="Withdraw" />
        </h1>
        <section className={ccn("deposit")}>
          <h3 className={invest && invest.currency === "BTC" ? "btc" : null}>
            <i>{getCurrencySymbol(get(invest, "currency", "USD"))}</i>
            <span>
              {invest && invest.amount ? parseFloat(invest.amount).toLocaleString("en-US", {
                minimumFractionDigits: invest && invest.currency === "BTC" ? investCountDecimals : 2,
                maximumFractionDigits: invest && invest.currency === "BTC" ? investCountDecimals : 2
              }) : "0"}
            </span>
            <span>{` ${get(invest, "currency", "USD")}`}</span>
          </h3>
          {<h4 className={ccn("status")}>Status: waitlist</h4>}
          <div className={ccn("btn-row")}>
            <Button onClick={this.openModal} className="Button--cancel" disabled={!get(user, "invest")}>
              <FormattedMessage id="hbc.withdraw.cancel.deposit.button" defaultMessage="cancel deposit" />
            </Button>
          </div>
        </section>

        <Modal
          classNames={{ overlay: ccn("modal"), modal: ccn("modal-body") }}
          open={modal}
          onClose={this.closeModal}
        >
          <h1>
            <FormattedMessage id="hbc.invest.cancel.deposit" defaultMessage="Cancel Deposit" />
          </h1>
          <h2>
            <FormattedMessage
              id="hbc.invest.cancel.deposit.message"
              defaultMessage="Do you really want to cancel deposit and forfeit your spot on the waitlist?"
            />
          </h2>
          <div className={ccn("btn-row")}>
            <Button className="Button--red Button--ok-no" onClick={this.handleRemoveInvest}>
              <FormattedMessage id="hbc.invest.cancel.deposit.ok" defaultMessage="ok" />
            </Button>
            <Button className="Button--ok-no" onClick={this.closeModal}>
              <FormattedMessage id="hbc.invest.cancel.deposit.no" defaultMessage="no" />
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}
const mapStateToProps = ({ user }) => ({
  user: user.info
});

export default connect(mapStateToProps, { deleteInvest })(injectIntl(CancelDeposit));



// WEBPACK FOOTER //
// ./src/containers/withdraw/cancelDeposit/CancelDeposit.js